(() => {
  const script = document.currentScript;
  const token = script?.dataset.projectToken?.trim();
  const hostValue = script?.dataset.apiHost?.trim();
  if (!token || !hostValue) return;

  let host;
  try {
    const parsed = new URL(hostValue);
    if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return;
    host = parsed.origin;
  } catch {
    return;
  }

  let initialized = false;
  let optedOut = false;

  function safePathname(pathname) {
    const path = String(pathname || '/').split(/[?#]/, 1)[0].replace(/\/{2,}/g, '/');
    if (/^\/(?:account|orders|checkouts?)(?:\/|$)/i.test(path)) return `/${path.split('/')[1]}/*`;
    return path.slice(0, 256) || '/';
  }

  function safeSdkEvent(event) {
    if (!event || !event.properties) return event;
    const properties = { ...event.properties };
    for (const [key, value] of Object.entries(properties)) {
      if (/^(?:\$?utm_|\$?(?:gclid|fbclid|msclkid)|\$title$)/i.test(key)) {
        delete properties[key];
        continue;
      }
      if (typeof value !== 'string' || !/(?:url|href|referrer)/i.test(key)) continue;
      try {
        const url = new URL(value, window.location.origin);
        properties[key] = /referrer/i.test(key) ? url.origin : `${url.origin}${safePathname(url.pathname)}`;
      } catch {
        delete properties[key];
      }
    }
    if (event.event === '$autocapture' && Array.isArray(properties.$elements)) {
      properties.$elements = properties.$elements.map((element) => ({
        tag_name: element?.tag_name,
        nth_child: element?.nth_child,
      }));
      delete properties.$el_text;
      delete properties.$el_attr__href;
      delete properties.$el_attr__value;
    }
    if (event.event === '$autocapture') {
      delete properties.$el_text;
      delete properties.$el_attr__href;
      delete properties.$el_attr__value;
      delete properties.$elements_chain;
    }
    return { ...event, properties };
  }

  function redactReplayNetwork(request) {
    if (!request || typeof request !== 'object') return null;
    try {
      const url = new URL(request.name, window.location.origin);
      if (/^\/(?:account|orders|checkouts?)(?:\/|$)/i.test(url.pathname)) return null;
      request.name = `${url.origin}${safePathname(url.pathname)}`;
      delete request.requestBody;
      delete request.responseBody;
      delete request.requestHeaders;
      delete request.responseHeaders;
      return request;
    } catch {
      return null;
    }
  }

  function initialize() {
    if (window.posthog?.__SV) return;
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    window.posthog.init(token, {
      api_host: host,
      defaults: '2026-05-30',
      before_send: safeSdkEvent,
      enable_recording_console_log: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
        maskTextFn: (text) => text
          .replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '[MASKED]')
          .replace(/\b[A-HJ-NPR-Z0-9]{17}\b/gi, '[MASKED]')
          .replace(/\+?[\d() .-]{10,}\d/g, '[MASKED]'),
        streamNetworkBody: false,
        maskCapturedNetworkRequestFn: redactReplayNetwork,
      },
    });
    initialized = true;
  }

  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    if (privacy.analyticsProcessingAllowed()) {
      if (!initialized) initialize();
      else if (optedOut) {
        window.posthog.opt_in_capturing();
        window.posthog.capture('$pageview');
        optedOut = false;
      }
    } else if (initialized && !optedOut) {
      window.posthog.opt_out_capturing();
      optedOut = true;
    }
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) syncConsent(); },
    );
  }
})();
